import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormDatePicker from "../../components/formFields/FormDateField";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { RootState } from "../../app/store";
import {
  getKarigarListByProcess,
  getKarigarStock,
} from "../karigar/services/karigar.services";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import { IKarigarListByProcess } from "../karigar/karigarModel";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { findAllActiveItem } from "../item/services/item.services";
import { findAllActivePurity } from "../purity/services/purity.services";
import { findAllActiveItemCategory } from "../itemcategory/services/itemcategory.services";
import { clearOrderDetail } from "../order/orderSlice";
import { openDialog } from "../../components/dialog/dialogSlice";

import { findAllActiveUnit } from "../unit/services/unit.services";
import FormTextArea from "../../components/formFields/FormTextArea";
import {
  clearBandhaiDetail,
  setBandhaiOrderItemIndex,
  setBandhaiOrderSave,
} from "./bandhaiSlice";
import {
  createBandhai,
  getBandhaiById,
  updateBandhai,
} from "./services/bandhai.services";
import BandhaiOrderListArray from "./BandhaiOrderListArray";
import BandhaiEntryDetailArray from "./BandhaiEntryDetailArray";
import BandhaiOrderItemDetailsArray from "./BandhaiOrderItemDetailsArray";
import { findAllOrder } from "../order/services/order.services";
import { PRINT_ACCESS, PROCESS_ID } from "../../_contstants/common";
import { clearKarigarStock } from "../karigar/karigarSlice";
import { clearItemDetail } from "../item/itemSlice";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { FaEye } from "react-icons/fa";
import { ErrorToast } from "../../components/toast/Toasts";
import { findAllActiveProcess } from "../process/services/process.services";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const KarigarChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const karigar_id = formRenderProps.valueGetter("karigar_id");
  const KarigarList = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const bandhai_Entry_item = formRenderProps.valueGetter("bandhai_Entry_item");

  const fetchKarigarStock = async (karigar_id: number) => {
    await dispatch(getKarigarStock(karigar_id));
  };
  useEffect(() => {
    if (karigar_id) {
      fetchKarigarStock(karigar_id);
    }
  }, [karigar_id]);

  useEffect(() => {
    if (karigar_id && KarigarList?.length > 0) {
      const selectedKarigar = KarigarList.find(
        (karigar) => karigar.karigar_id === karigar_id,
      );
      if (selectedKarigar) {
        const wastage = selectedKarigar?.wastage;
        const wastage_type = selectedKarigar?.wastage_type;

        formRenderProps.onChange(`karigar_given_wastage`, {
          value: wastage || 0,
        });
        formRenderProps.onChange(`karigar_given_wastage_type`, {
          value: wastage_type,
        });

        // bandhai_Entry_item?.forEach((element: any, index: number) => {
        //   formRenderProps.onChange(`bandhai_Entry_item.${index}.given_wastage`, {
        //     value: wastage || 0,
        //   });
        //   formRenderProps.onChange(
        //     `bandhai_Entry_item.${index}.given_wastage_type`,
        //     { value: wastage_type }
        //   );
        // });
      }
    }
  }, [karigar_id, bandhai_Entry_item, KarigarList]);

  return null;
};

const TotalChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const bandhai_Entry_item = formRenderProps.valueGetter("bandhai_Entry_item");

  let weight_total = 0;
  // let phine_total = 0;
  let pcs_total = 0;
  useEffect(() => {
    if (bandhai_Entry_item && bandhai_Entry_item.length > 0) {
      bandhai_Entry_item?.map((item: any) => {
        weight_total += +item.given_weight;
        // phine_total += +item.phine;
        pcs_total += +item.pcs;
      });
    }
    formRenderProps.onChange(`weight_total`, {
      value: weight_total || "",
    });
    // formRenderProps.onChange(`phine_total`, {
    //   value: phine_total.toFixed(3) || "",
    // });
    formRenderProps.onChange(`pcs_total`, {
      value: pcs_total || "",
    });
  }, [
    bandhai_Entry_item?.map((item: any) => item?.given_weight).join("-"),
    bandhai_Entry_item?.map((item: any) => item?.phine).join("-"),
    bandhai_Entry_item?.map((item: any) => item?.pcs).join("-"),
  ]);
  return null;
};

const CreateBandhai: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const isPrintAccess = checkAcessRights(
    "/" + location.pathname.split("/")[1],
    PRINT_ACCESS,
  );

  const bandhai_issue_guid = location?.state?.ID;
  const BandhaiOrderSave = useAppSelector(
    (state) => state.bandhai?.BandhaiOrderSave,
  );
  const loading = useAppSelector((state) => state.bandhai.loading);

  const karigarStock = useAppSelector((state) => state.karigar.KarigarStock);

  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );

  const BandhaiDetail = useAppSelector(
    (state: RootState) => state.bandhai.BandhaiDetail,
  );
  const FilterOrder = useAppSelector((state) => state.order.FilterOrder);

  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    const payload = {
      ...FilterOrder,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
      ProcessID: PROCESS_ID.bandhai,
    };
    dispatch(findAllOrder(payload));
  }, [currentPage, pageLimit]);

  const today = new Date();
  const maxDate =
    new Date(today.getFullYear(), today.getMonth(), today.getDate()) || null;

  useEffect(() => {
    dispatch(getKarigarListByProcess(PROCESS_ID.bandhai));
    dispatch(findAllActiveItem());
    dispatch(findAllActiveUnit());
    dispatch(findAllActivePurity());
    dispatch(findAllActiveItemCategory());
    dispatch(findAllActiveProcess());
    return () => {
      dispatch(clearBandhaiDetail());
      dispatch(clearOrderDetail());
      dispatch(clearItemDetail());
      dispatch(clearKarigarStock());
    };
  }, []);

  useEffect(() => {
    if (bandhai_issue_guid) {
      dispatch(getBandhaiById(bandhai_issue_guid));
    }
  }, [bandhai_issue_guid]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [BandhaiDetail]);

  const handleSubmit = async (values: any) => {
    if (BandhaiOrderSave) return false;
    if (!(values.bandhai_order.length || values.bandhai_Entry_item.length)) {
      ErrorToast(
        "Either Order Entry or Gold Issue Entry must be compulsory before saving the record.",
      );
      return;
    }
    const formData = {
      karigar_id: values.karigar_id ? +values.karigar_id : 0,
      issue_date: values.issue_date
        ? moment(values.issue_date).format("YYYY-MM-DD")
        : "",
      approx_delivery_date: values.approx_delivery_date
        ? moment(values.approx_delivery_date).format("YYYY-MM-DD")
        : null,

      given_amount: values?.given_amount,
      remarks: values.remarks,
      isactive: true,
      bandhai_order: values.bandhai_order
        ? values.bandhai_order.map((ghat_info: any) => {
            return {
              id: ghat_info.id ? ghat_info.id : 0,
              order_id: ghat_info.order_id ? +ghat_info.order_id : null,
              process_id: ghat_info.process_id ? +ghat_info.process_id : null,
              item_id: ghat_info.item_id ? +ghat_info.item_id : null,
              item_category_id: ghat_info.item_category_id
                ? +ghat_info.item_category_id
                : null,
              purity_id: ghat_info.purity_id ? +ghat_info.purity_id : null,
              weight: ghat_info.weight ? +ghat_info.weight : 0,
              remarks: ghat_info.remarks,
              order_no: ghat_info.order_no ? +ghat_info.order_no : null,
              // phine: ghat_info.phine ? +ghat_info.phine : "",
              // rupees: ghat_info.rupees ? +ghat_info.rupees : "",

              approval_items: ghat_info.approval_items
                ? ghat_info.approval_items?.map((approve: any) => {
                    return {
                      id: approve?.id ? approve.id : 0,
                      IssueDate: approve?.IssueDate
                        ? moment(approve?.IssueDate).format("YYYY-MM-DD")
                        : null,
                      order_id: approve?.order_id
                        ? +approve.order_id
                        : +ghat_info.order_id
                          ? +ghat_info.order_id
                          : null,
                      type: approve?.type ? approve.type : "",
                      item_id: approve?.item_id ? +approve.item_id : null,
                      weight: approve?.weight ? +approve.weight : 0,
                      qty: approve?.qty ? +approve.qty : 0,
                      unit_id: approve?.unit_id ? +approve.unit_id : null,
                      remarks: approve?.remarks ? approve.remarks : "",
                    };
                  })
                : [],
            };
          })
        : [],
      bandhai_Entry_item: values.bandhai_Entry_item
        ? values.bandhai_Entry_item.map((item: any) => {
            return {
              id: item.id ? item.id : 0,
              item_id: item.item_id ? item.item_id : 0,
              IssueDate: item.IssueDate
                ? moment(item.IssueDate).format("YYYY-MM-DD")
                : null,
              given_weight: item.given_weight ? +item.given_weight : 0,
              given_purity: item.given_purity ? +item.given_purity : 0,
              PurityID: item.PurityID ? +item.PurityID : 0,
              given_wastage: item.given_wastage ? +item.given_wastage : 0,
              phine: item.phine ? +item.phine : 0,
              pcs: item.pcs ? +item.pcs : 0,
            };
          })
        : [],
    };
    if (bandhai_issue_guid) {
      const editPayload = {
        bandhai_issue_guid: bandhai_issue_guid,
        issue_no: values.issue_no,
        ...formData,
      };
      try {
        const response = await dispatch(updateBandhai(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/bandhai");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createBandhai(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/bandhai");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };
  const handleFormClose = () => {
    navigate("/bandhai");
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={BandhaiDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <KarigarChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {bandhai_issue_guid
                      ? "Update Bandhai Issue"
                      : "Create Bandhai Issue"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  {bandhai_issue_guid ? (
                    <Typography.h5>
                      Bandhai No :{" "}
                      <span style={{ color: "green" }}>
                        {BandhaiDetail.issue_no}
                      </span>
                    </Typography.h5>
                  ) : (
                    ""
                  )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="karigar_id"
                    label="Karigar Name"
                    placeholder="Select Karigar"
                    isAddNew={true}
                    addNewLink="karigar/create"
                    dispatcherFunction={getKarigarListByProcess}
                    dispatcherFunctionPayload={PROCESS_ID.bandhai}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={KarigarListByProcess?.map(
                      (karigar: IKarigarListByProcess) => {
                        return {
                          value: karigar?.karigar_id,
                          label: `${karigar?.karigar_nick_name || karigar?.karigar_name}`,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="issue_date"
                    label="Issue Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    component={FormDatePicker}
                    max={maxDate}
                    value={new Date()}
                    validator={requiredValidator}
                    astrike={true}
                  />
                  {/* <Field
                    name="approx_delivery_date"
                    label="Approx Delivery Date"
                    format={"dd/MM/yyyy"}
                    placeholder="day/month/year"
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  /> */}
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>

            {loading ? (
              <LoadingPanel gridRef={gridRef} />
            ) : (
              <ShadowCard style={{ marginTop: 10 }}>
                <Typography.h4 style={{ margin: 0 }}>Order List</Typography.h4>
                {formRenderProps.valueGetter("bandhai_order")?.length > 0 ? (
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={BandhaiOrderListArray}
                    name="bandhai_order"
                  />
                ) : (
                  <></>
                )}
                <div style={{ marginTop: 10 }}>
                  <Button
                    type="button"
                    themeColor={"primary"}
                    onClick={() => {
                      dispatch(openDialog("show-bandhai-items-details-dialog"));
                      dispatch(setBandhaiOrderItemIndex(999));
                      dispatch(setBandhaiOrderSave(true));
                    }}
                    fillMode="solid"
                  >
                    Add New Order
                  </Button>
                </div>
                <FieldArray
                  formRenderProps={formRenderProps}
                  component={BandhaiOrderItemDetailsArray}
                  name="bandhai_order"
                />
              </ShadowCard>
            )}

            {/* <ShadowCard style={{ marginTop: 10 }}>
              <Typography.h4>Order List</Typography.h4>
              {formRenderProps.valueGetter("bandhai_order")?.length > 0 ? (
                <FieldArray
                  formRenderProps={formRenderProps}
                  component={BandhaiOrderListArray}
                  name="bandhai_order"
                />
              ) : (
                <AlertBox />
              )}
              <div style={{ marginTop: 10 }}>
                <Button
                  type="button"
                  themeColor={"info"}
                  onClick={() => {
                    dispatch(openDialog("show-bandhai-items-details-dialog"));
                    dispatch(setBandhaiOrderItemIndex(999));
                  }}
                  fillMode="solid"
                >
                  Add New Order
                </Button>
              </div>
              <FieldArray
                formRenderProps={formRenderProps}
                component={BandhaiOrderItemDetailsArray}
                name="bandhai_order"
              />
            </ShadowCard> */}

            <TotalChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayoutItem colSpan={4}>
                <Typography.h4>Gold Issue Detail</Typography.h4>
              </GridLayoutItem>
              <FieldArray
                formRenderProps={formRenderProps}
                component={BandhaiEntryDetailArray}
                name="bandhai_Entry_item"
              />
              <GridLayout
                style={{ marginRight: 40 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "20%" },
                  { width: "20%" },
                  { width: "20%" },
                  { width: "20%" },
                  { width: "20%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <div className="stock-container">
                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot amount-dot-${karigarStock.Amount_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Amount Balance
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value amount-value-${karigarStock.Amount_credit_debit}`}
                      >
                        {formatToIndianCurrencyWithoutSymbol(
                          karigarStock.amount || 0,
                        )}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.Amount_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>

                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot phine-dot-${karigarStock.phine_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Phine (gm) Stock
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value phine-value-${karigarStock.phine_credit_debit}`}
                      >
                        {formatWeight(karigarStock.phine)}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.phine_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>
                  </div>
                </GridLayoutItem>
                {formRenderProps.valueGetter("bandhai_Entry_item")?.length >
                  0 && (
                  <>
                    <GridLayoutItem>
                      <Field
                        name="weight_total"
                        label="Total Given Weight (gm)"
                        format="n3"
                        placeholder="0.000"
                        type="number"
                        component={FormNumericTextField}
                        disabled
                      />
                    </GridLayoutItem>
                    {/* <GridLayoutItem >
                    <Field
                      name="phine_total"
                      label="Total Phine (gm)"
                      component={FormTextField}
                      placeholder="0"
                      disabled
                    />
                  </GridLayoutItem> */}
                    <GridLayoutItem>
                      <Field
                        name="pcs_total"
                        label="Total PCS"
                        placeholder="0"
                        component={FormTextField}
                        disabled
                      />
                    </GridLayoutItem>
                  </>
                )}
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={2}>
                  <Field
                    rows={2}
                    name="remarks"
                    label="Remarks"
                    placeholder="Write Here..."
                    component={FormTextArea}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="given_amount"
                    label="Given Amount"
                    placeholder="0"
                    type="number"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={3}
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  {isPrintAccess && bandhai_issue_guid && (
                    <Button
                      type="button"
                      style={{ marginRight: 4 }}
                      fillMode={"solid"}
                      themeColor={"primary"}
                      onClick={() =>
                        window.open(
                          `/bandhaiissue/${bandhai_issue_guid}`,
                          "_blank",
                        )
                      }
                    >
                      <FaEye style={{ fontSize: "18" }} /> View Report
                    </Button>
                  )}
                  <ButtonWithLoading
                    label={!bandhai_issue_guid ? "Create" : "Update"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateBandhai;
